/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingContactSummary } from './';
import {
    BillingContactSummaryFromJSON,
    BillingContactSummaryFromJSONTyped,
    BillingContactSummaryToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntitySummaryResource
 */
export interface LegalEntitySummaryResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntitySummaryResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntitySummaryResource
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntitySummaryResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {PostalAddress}
     * @memberof LegalEntitySummaryResource
     */
    address?: PostalAddress;
    /**
     * 
     * @type {BillingContactSummary}
     * @memberof LegalEntitySummaryResource
     */
    billingContactSummary?: BillingContactSummary;
    /**
     * 
     * @type {Set<string>}
     * @memberof LegalEntitySummaryResource
     */
    clientTeams: Set<string>;
    /**
     * 
     * @type {number}
     * @memberof LegalEntitySummaryResource
     */
    missingInformationNotificationCount: number;
    /**
     * True when a company identity has been assigned to the legal entity.
     * @type {boolean}
     * @memberof LegalEntitySummaryResource
     */
    isVerified: boolean;
}

/**
 * Check if a given object implements the LegalEntitySummaryResource interface.
 */
export function instanceOfLegalEntitySummaryResource(value: object): value is LegalEntitySummaryResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    if (!('missingInformationNotificationCount' in value) || value['missingInformationNotificationCount'] === undefined) return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined) return false;
    return true;
}

export function LegalEntitySummaryResourceFromJSON(json: any): LegalEntitySummaryResource {
    return LegalEntitySummaryResourceFromJSONTyped(json, false);
}

export function LegalEntitySummaryResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntitySummaryResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'address': json['address'] == null ? undefined : PostalAddressFromJSON(json['address']),
        'billingContactSummary': json['billingContactSummary'] == null ? undefined : BillingContactSummaryFromJSON(json['billingContactSummary']),
        'clientTeams': json['clientTeams'],
        'missingInformationNotificationCount': json['missingInformationNotificationCount'],
        'isVerified': json['isVerified'],
    };
}

export function LegalEntitySummaryResourceToJSON(value?: LegalEntitySummaryResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'address': PostalAddressToJSON(value['address']),
        'billingContactSummary': BillingContactSummaryToJSON(value['billingContactSummary']),
        'clientTeams': Array.from(value['clientTeams'] as Set<any>),
        'missingInformationNotificationCount': value['missingInformationNotificationCount'],
        'isVerified': value['isVerified'],
    };
}

